function QuoteResultModelBuilder(Util) {
	var quoteResultsByType= {} ;

	function addQuoteResult(quoteResult) {
		var quoteCoverIndicator = quoteResult.coverType;
		if ( quoteResult.offering )
			quoteCoverIndicator += '_' + quoteResult.offering ; 

		if ( ! quoteResultsByType[quoteCoverIndicator] ) 
			quoteResultsByType[quoteCoverIndicator] = new MergedQuoteResultModel(Util, quoteCoverIndicator);

		quoteResultsByType[quoteCoverIndicator].addQuoteResult(quoteResult) ; 
	}

	function getMergedQuoteResults(quoteResults) {
		return quoteResultsByType;
	}

	function clear() {
		quoteResultsByType = {}; 
	}

	return {
		clear: clear,
		addQuoteResult: addQuoteResult,
		getMergedQuoteResults: getMergedQuoteResults,
	}
}
